var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "414px",
    height: "122px",
    viewBox: "0 0 414 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "web_ethizo_logo_login copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.279938735 0.225846884 83.1545164 0.225846884 83.1545164 82.7397332 0.279938735 82.7397332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 75.5131763 0 75.5131763 119.62099 0 119.62099"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "2.27373675e-13 124.689677 412.282158 124.689677 412.282158 8.17124146e-13 2.27373675e-13 8.17124146e-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web_ethizo_logo_login-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.098926, 36.494539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0802648,53.1645335 L20.2274886,41.7731894 L62.775806,23.3363727 C57.9168397,16.8393199 51.0631185,13.5902876 42.2115843,13.5902876 C34.6779951,13.5902876 28.3063991,16.2251304 23.0988349,21.4978515 C17.8902514,26.7695608 15.2869789,33.166441 15.2869789,40.6854566 C15.2869789,48.6962287 17.8698655,55.3986859 23.0366581,60.7928284 C28.2024313,66.1879826 34.8013295,68.8845479 42.8292755,68.8845479 C55.7141491,68.8845479 64.6074742,61.5901617 69.5061929,46.9993656 L83.1545164,50.1259648 C75.2499048,71.868477 61.7667066,82.7397332 42.7059411,82.7397332 C31.2195364,82.7397332 21.2763403,78.7146162 12.8783913,70.6633704 C4.4804422,62.6121246 0.279938735,52.9055013 0.279938735,41.5445125 C0.279938735,29.9376455 4.31429756,20.1490629 12.3840345,12.1797765 C20.4527521,4.21049009 30.3551766,0.225846884 42.0913079,0.225846884 C59.8759195,0.225846884 73.2979601,9.67040242 82.3564106,28.5595135 L26.0802648,53.1645335 Z",
    id: "Fill-1",
    fill: "#3BC9B0",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "translate(94.481328, 15.460581)",
    fill: "#98A6AD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0004422,88.8320351 L45.0004422,103.919116 L44.4574912,103.919116 C36.6419096,103.919116 28.826328,103.948262 21.0128267,103.908707 C16.4362284,103.887889 12.3110492,102.476403 8.76210533,99.5597473 C6.31362528,97.5445279 4.65148801,94.9026753 3.26810719,92.0942756 C1.51761005,88.5306416 0.485572729,84.6568803 0.230910183,80.6941297 C0.0852911487,78.5748184 0.0228829911,76.445098 0.0104013596,74.321623 C-0.00346711987,49.814224 -0.00346711987,25.3075189 0.0104013596,0.801507699 L0.0104013596,0 L14.7387266,0 L14.7387266,20.4478146 L46.3817427,20.4478146 L46.3817427,35.3745944 L14.734566,35.3745944 L14.734566,36.1427926 C14.734566,50.5657675 14.7553687,64.9866606 14.7220844,79.4075537 C14.7220844,83.4255014 17.5013277,87.2789838 21.2250144,88.6071966 C22.7581748,89.15472 24.3121379,89.194275 25.903546,89.1609656 C32.1443617,89.0305037 38.3900314,88.9139208 44.6405551,88.8112167 C44.7508096,88.8132986 44.8631442,88.8237078 45.0004422,88.8320351 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(150.118436, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.572277,2.19488056 L15.572277,45.7748121 C19.0772306,43.2921186 22.7840796,41.1824065 26.696586,39.4422115 C30.6053304,37.7043261 35.1210148,36.8359607 40.2474014,36.8359607 C49.4129492,36.8359607 57.402237,39.288631 64.2127569,44.191662 C71.0195148,49.0981572 74.4266558,55.8314529 74.4266558,64.3984776 L74.4266558,119.523511 L58.6512294,119.523511 L58.6512294,72.0336262 C58.6512294,65.578623 56.7614387,60.4873693 52.9881273,56.7621743 C49.2110538,53.038134 44.493474,51.1755365 38.8303718,51.1755365 C32.0875683,51.1755365 26.998802,52.7898647 23.5615649,56.0173662 C20.1230737,59.2471772 17.796888,62.7853042 16.5842618,66.6329017 C16.1792171,67.7495364 15.9083513,68.8996586 15.7741724,70.0786494 C15.6399935,71.2587948 15.572277,72.4054528 15.572277,73.5232423 L15.572277,119.523511 L0,119.523511 L0,2.19488056 L15.572277,2.19488056 Z",
    id: "Fill-6",
    fill: "#98A6AD",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.700036,119.356105 L252.816356,119.356105 L252.816356,36.5681461 L235.700036,36.5681461 L235.700036,119.356105 Z M235.700036,10.2152958 C235.700036,7.486022 236.535161,5.43967101 238.206484,4.0738254 C239.876735,2.70918851 241.924347,2.02747442 244.345032,2.02747442 C244.690231,2.02747442 245.063304,2.06131838 245.468538,2.12538016 C245.871628,2.19306809 246.246845,2.28976512 246.593116,2.41788869 C248.205477,2.80709425 249.645237,3.68461984 250.915614,5.04925673 C252.182775,6.41389363 252.816356,8.20158005 252.816356,10.4098986 C252.816356,13.2709221 251.979086,15.4792406 250.309907,17.0384803 C248.637512,18.5977199 246.822535,19.443819 244.862831,19.5719426 L244.604467,19.5719426 L244.345032,19.5719426 C242.153765,19.5719426 240.166188,18.7923227 238.380156,17.233083 C236.59198,15.6738434 235.700036,13.4014631 235.700036,10.4098986 L235.700036,10.2152958 Z",
    id: "Fill-9",
    fill: "#98A6AD",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.956693,36.4945395 C314.61498,36.6234342 317.985823,37.8741903 320.072644,40.2480014 C322.154904,42.6241994 323.198314,45.2844431 323.198314,48.2358934 C323.198314,48.8791736 323.167525,49.4866496 323.107087,50.0642889 C323.044368,50.6419282 322.891563,51.2517911 322.64753,51.8926843 C322.279201,53.5623483 321.664558,55.1974016 320.808163,56.8014248 C319.949487,58.4066414 318.906077,59.8495462 317.681352,61.132526 L282.370744,105.980727 L324.302163,105.980727 L324.302163,119.453805 L275.933528,119.453805 C272.990312,119.5827 270.415426,118.716241 268.208869,116.854428 C266.002312,114.995003 264.898464,112.653415 264.898464,109.828473 C264.898464,108.933371 265.01934,108.001271 265.266794,107.038141 C265.509686,106.076204 265.879156,105.084431 266.369502,104.054467 C266.737831,103.284679 267.197388,102.514891 267.749312,101.745103 C268.301237,100.975315 268.880529,100.205527 269.497453,99.434546 L306.094364,51.315045 L268.208869,51.315045 L268.208869,36.4945395 L309.956693,36.4945395 Z",
    id: "Fill-11",
    fill: "#98A6AD",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#98A6AD",
    strokeWidth: 16,
    cx: 371.546946,
    cy: 77.9804316,
    rx: 33.203729,
    ry: 33.4858921
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.636759bcde7c4e20edd2c8dd2f5b9f6a.svg";
export { ForwardRef as ReactComponent };